<template>
  <div class="home mb-5">
    <CCard v-if="isOrganizationSuspended">
      <CCardHeader class="bg-gray-200 pt-4">
        <section class="d-flex justify-content-center align-items-center">
          <div class="card-header-actions">
            {{ $t('managePlan.text.suspended-plan') }}
          </div>
        </section>
      </CCardHeader>
    </CCard>
    <CRow class="py-5">
      <CCol sm="12" md="8" lg="7">
        <InfoUser
          :isVisibleManageBalance="isVisibleManageBalance"
          :isVisibleManagePacks="isVisibleManagePacks"
          :isOrganizationApproved="isOrganizationApproved"
        />
      </CCol>
      <CCol sm="12" md="4" lg="5" v-if="isVisibleBalance">
        <Balance :balances="currentBalance" />
      </CCol>
    </CRow>
    <CRow alignHorizontal="center" alignVertical="strech">
      <CCol class="pr-2">
        <div class="card-home-board" style="height: 100%">
          <WrapperListCampaign
            :titleList="$t('campaign.campaignList.text.campaigns')"
            :textLinkList="$t('campaign.campaignList.text.allCampaign')"
            linkList="campaignList"
            :loading="loading"
            :isNewCampaignBtnAvailable="true"
          >
            <template slot="list" v-if="campaignList.length">
              <listCampaign :list="campaignList" :showDetailList="true" />
            </template>
            <template v-else slot="emptyList">
              <EmptyList
                colorBackground="bg-white"
                :linkTo="{ name: 'campaign' }"
                :title="$t('campaign.campaignList.text.noCampaign')"
                :subTitle="$t('campaign.campaignList.text.createCampaign')"
                :linkText="$t('campaign.campaignList.button.createCampaign')"
              />
            </template>
          </WrapperListCampaign>
        </div>
      </CCol>
      <CCol class="pl-2">
        <div class="card-home-board" style="height: 100%">
          <WrapperListCampaign
            :titleList="$t('campaign.campaignList.text.drafts')"
            :loading="loading"
            linkList="campaignList"
            :textLinkList="$t('campaign.campaignList.text.allCampaign')"
          >
            <template slot="list" v-if="draftList.length">
              <listCampaign :list="draftList" :hasEditIcons="true" />
            </template>
            <template v-else slot="emptyList">
              <EmptyList
                colorBackground="bg-white"
                :icon="{
                  name: 'editFull',
                  colorBackground: 'gray-200',
                  class: 'text-success',
                  height: 18,
                }"
                :subTitle="$t('campaign.campaignList.text.noDrafts')"
              />
            </template>
          </WrapperListCampaign>
        </div>
      </CCol>
    </CRow>

    <SupportBlocks class="mt-4" />
  </div>
</template>

<script>
import Balance from './components/Balance.vue'
import InfoUser from './components/InfoUser.vue'
import EmptyList from '../../components/EmptyList.vue'
import listCampaign from './components/listCampaign.vue'
import WrapperListCampaign from './components/WrapperCampaignList.vue'
import SupportBlocks from './components/SupportBlocks.vue'
import { dateFormatStringMed } from './../../utils/dateUtil'
import { organizationType, organizationBalanceConfigType } from '@/utils/enumsUtils.js'
import services from '@/services.js'
import { ORGANIZATION_PLAN_STATUS } from '../auth/constants'

const campaignStatus = {
  1: 'Draft',
  2: 'Calculating',
  3: 'Ready-to-Send',
  4: 'Sent',
  5: 'On-going',
  6: 'Scheduled',
  7: 'Deleted',
  8: 'Pending-Balance',
  9: 'Balance-Updated',
  10: 'Pending_Outbox_Dispatch',
}

const channelTypeCode = {
  1: 'email',
  2: 'sms',
}

export default {
  name: 'Home',
  components: { InfoUser, WrapperListCampaign, EmptyList, listCampaign, SupportBlocks, Balance },
  data() {
    return {
      isOrganizationSuspended: false,
      loading: false,
      filters: {
        Page: 1,
        Count: 5,
      },
      draftList: [],
      campaignList: [],
      organizationId: null,
      currentBalance: [
        {
          channel: 1,
          currentBalance: 0,
        },
        {
          channel: 2,
          currentBalance: 0,
        },
      ],
      isSendit: null,
      planName: null,
      balanceConfigType: null,
      accountContextOwn: null,
      featuresIds: ['BALANCE'],
      balanceOrganization: undefined,
    }
  },

  created() {
    this.organizationId = this.$route.params.organizationId //this.$store.state.auth.organizationId
    this.isSendit = organizationType(this.$store.state.auth.session.organization.organizationType) == 'sendit'
    this.planName = this.$store.state.auth.session.organization.planName.toUpperCase()
    this.balanceConfigType = organizationBalanceConfigType(this.$store.state.auth.session.organization.organizationBalanceConfigType)
    this.accountContextOwn = this.$store.state.auth.session.organization.organizationBaseId == this.$route.params.organizationId
  },

  mounted() {
    this.$store.commit('backOffice/steps/RESET_STEP')
    this.isOrganizationSuspended = this.$store?.state?.auth?.organizationPlanStatus == ORGANIZATION_PLAN_STATUS.SUSPENDED
    this.getData({ ...this.filters, Status: [3, 4, 5, 6] }, 'campaignList')
    this.getData({ ...this.filters, Status: [1] }, 'draftList')
    this.getBalance()
  },

  computed: {
    features() {
      return this.$store.getters['auth/getFeatures'](this.featuresIds) || []
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience
    },

    isVisibleBalance() {
      if (this.balanceConfigType == 'NO_OWN_BALANCE') {
        return false
      }

      return true
    },

    isVisibleManagePacks() {
      if (this.accountContextOwn && !this.isSendit && this.planName !== 'FREE') {
        return true
      } else if (this.accountContextOwn && this.isSendit && this.isOwnBalance() && this.planName !== 'FREE') {
        return true
      } else {
        return false
      }
    },

    isVisibleManageBalance() {
      if (!this.accountContextOwn && this.isOwnBalance() && this.planName !== 'FREE') {
        return true
      }
      return false
    },

    isOrganizationApproved() {
      return this.balanceOrganization?.isApproved
    },
  },

  methods: {
    getData(filters, nameList) {
      this.loading = true

      services
        .getCampaigns(this.organizationId, filters)
        .then((res) => {
          this[nameList] = res.data.data.campaigns.map((campaign) => {
            let channelTypes = []
            try {
              channelTypes = campaign.campaignWorkflow.values.reduce((ac, cv) => {
                if (ac.indexOf(cv.channel) === -1) ac.push(this.selectChannelType(cv.channel))
                return ac
              }, [])
            } catch (err) {
              // Não tem tratamento
            }
            return {
              id: campaign.campaignId,
              name: campaign.name,
              campaignStatus: campaignStatus[campaign.campaignStatus] ?? '',
              recepients: 0, // TODO alterar quando  já possuir esses dados após o processamento da campaign
              channels: [...new Set(channelTypes)],
              user: campaign.organizationUserId, // TODO trocar pelo valor de integração, quando for criada
              action: '',
              lastUpdate: campaign.updatedDateTime ? dateFormatStringMed(campaign.updatedDateTime) : dateFormatStringMed(campaign.autoSaveDateTime),
            }
          })
        })
        .catch(() => {
          this.type = []
        })
        .finally(() => {
          this.loading = false
        })
    },

    isOwnBalance() {
      return this.balanceConfigType == 'OWN_BALANCE_DEPENDENT' || this.balanceConfigType == 'OWN_BALANCE_INDEPENDENT'
    },

    selectChannelType(channelCode) {
      let channel = channelCode + ''
      return channelTypeCode[channel]
    },

    getBalance() {
      services
        .getCurrentBalanceOrganization(this.organizationId)
        .then((res) => {
          this.currentBalance = res.data.data.currentBalances
          this.balanceOrganization = res.data.data
        })
        .catch(() => {})
        .finally(() => {})
    },
  },
}
</script>

<style lang="scss">
.roundedIcon {
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  &--primary {
    background: lighten($primary, 37%);
  }
  &--warning {
    background: lighten($warning, 47%);
  }
  &--success {
    background: lighten($success, 47%);
  }
  &--gray-200 {
    background: $gray-200;
  }
}

.card-home-board {
  border: 1px solid #f1f3f5;
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  box-shadow: -6px 7px 7px -2px rgba(226, 226, 226, 0.75);
  -webkit-box-shadow: -6px 7px 7px -2px rgba(226, 226, 226, 0.75);
  -moz-box-shadow: -6px 7px 7px -2px rgba(226, 226, 226, 0.75);
}
</style>
